import React, { useEffect, useRef, useState } from 'react';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import { getHotelSearchByName } from '../utilities/getHotelSearchByName';
import HotelSearchResults from './HotelSearchResults';


const HotelFeedSearchModal = ({ language, save, show, handleClose }) => {
    const [searchedHotelName, setSearchedHotelName] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [selectedCode, setSelectedCode] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [visible, setVisible] = useState(10)
    const [totalItems, setTotalItems] = useState(0)
    
    useEffect(() => {
       if(show){
        setSearchResults([])
        setShowResults(false)
        setSearchedHotelName("")
        setSelectedCode(0);
       } 
    },[show])
    
    const showMoreResults = () => {
        if(visible >= totalItems){
            return;
        }
        setIsLoading(true); 
        setTimeout(() => {
            setVisible(prevValue => prevValue + 10);
            setIsLoading(false); 
        }, 1000); 
    };

    const handleChange = (e) => {
        setSearchedHotelName(e.target.value);
        setSearchResults([])
        setSelectedCode(0)
        setShowResults(false)
    };

    const handleClick = async () => {
        setLoading(true)
        setSearchResults([])
        setShowResults(false)
        setVisible(10)
        try {
            const data = await getHotelSearchByName(searchedHotelName.toUpperCase());
            console.log(data)
            if (!data) {
                console.log(data.message);
            } else {
                const dataResults = data?.statusCode !== 404 ? data?.filter(hotel => hotel.HotelStatus === 'Open' || 'OPEN') : data;
                setSearchResults(dataResults);
                setTotalItems(dataResults.length)
                setShowResults(true);
            }
        } catch (error) {
            console.log("Error fetching hotel search results", error);
        } finally {
            setLoading(false);
        }
    };

    const handleResultClick = (hotelCode) => {
        setSelectedCode(hotelCode);
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <ModalHeader closeButton>
                <ModalTitle>
                    <h4>{language.hotelDetails}<sup>*</sup></h4>
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <p>{language.pleaseProvideHotelName}</p>
                <div className="row">
                    <div className="col-8 col-md-12">
                        <input id="hotelName" name="hotelName" type="text" placeholder="Enter the name of hotel" className="form-control" value={searchedHotelName} onChange={handleChange} />
                    </div>
                    <div className="col-4">
                        <button id="btnModalCheck" className="btn btn-secondary mt-md-4" onClick={handleClick}>{language.search}</button>
                    </div>
                </div>

                {loading && <p className="mt-2">Loading...</p>}

                {showResults && searchResults.statusCode !== 404 ? (
                    <HotelSearchResults
                    hotelResults={searchResults}
                    language={language.result}
                    totalItems={totalItems}
                    isLoading={isLoading}
                    selectedCode={selectedCode}
                    showMoreResults={showMoreResults}
                    visible={visible}
                    handleResultClick={handleResultClick}
                    />
                ) : (
                    <div className="row mt-2">
                        <div className="col-12">
                            <h4>{searchResults.message}</h4>
                        </div>
                    </div>
                )}

            </ModalBody>
            <ModalFooter>
                <button onClick={handleClose} className="btn btn-secondary">Cancel</button>
                <button onClick={() => save(selectedCode)} type="button" id="btnModalSubmit" className={`btn ${(searchResults.statusCode === 404 || !selectedCode) ? "btn btn-secondary" : "btn btn-primary"}`} disabled={(searchResults.statusCode === 404 || !selectedCode) && true}>{language.saveAndApply}</button>
            </ModalFooter>
        </Modal>
    );
};

export default HotelFeedSearchModal;
